import { createAction, props } from '@ngrx/store';

import { BillingPayRates } from 'src/app/perdiem/components/pay-rate/models/pay-rates.model';
import { ShiftTypeLookup } from 'src/app/perdiem/components/pay-rate/models/rate-shift-differential.model';
import { FetchArgs } from 'src/app/shared/models/core';

export const getBillingPayRates = createAction(
    '[PAY RATE COMPONENT] Get Billing Pay Rates',
    props<{ facilityId: number }>()
);
export const getIncentivePayRates = createAction(
    '[PAY RATE COMPONENT] Get Incentive Pay Rates',
    props<{ facilityId: number; args: FetchArgs }>()
);
export const getBillingPayRatesSuccess = createAction(
    '[PAY RATE COMPONENT] Get Billing Pay Rates Success',
    props<{ billingRates: BillingPayRates }>()
);

export const getBillingPayRatesFailure = createAction(
    '[PAY RATE COMPONENT] Get Billing Pay Rates Failure',
    props<{ error: unknown }>()
);
export const getIncentivePayRatesSuccess = createAction(
    '[PAY RATE COMPONENT] Get Incentive Pay Rates Success',
    props<{ incentiveRates: BillingPayRates }>()
);
export const getIncentivePayRatesFailure = createAction(
    '[PAY RATE COMPONENT] Get Incentive Pay Rates Failure',
    props<{ error: unknown }>()
);

export const getShiftDiffLookupSuccess = createAction(
    '[PAY RATE COMPONENT] Get Shift Differential Lookup Success',
    props<{ shiftDifferentialTypes: ShiftTypeLookup[] }>()
);
export const getShiftDiffLookupFailure = createAction(
    '[PAY RATE COMPONENT] Get Shift Differential Lookup Failure',
    props<{ error: unknown }>()
);
export const updateBillingPayRates = createAction(
    '[PAY RATE COMPONENT] Update Billing Pay Rates',
    props<{ facilityId: number; billingRates: BillingPayRates }>()
);

export const updateBillingPayRatesSuccessNoUpdate = createAction(
    '[PAY RATE COMPONENT] Update Billing Pay Rates Success No Update'
);

export const updateIncentivePayRatesSuccessNoUpdate = createAction(
    '[PAY RATE COMPONENT] Update Incentive Pay Rates Success No Update'
);

export const updateBillingPayRatesFailure = createAction(
    '[PAY RATE COMPONENT] Update Billing Pay Rates Failure',
    props<{ error: unknown }>()
);
export const updateIncentivePayRates = createAction(
    '[PAY RATE COMPONENT] Update Incentive Pay Rates',
    props<{ facilityId: number; billingRates: BillingPayRates; args: FetchArgs }>()
);

export const updateIncentivePayRatesFailure = createAction(
    '[PAY RATE COMPONENT] Update Incentive Pay Rates Failure',
    props<{ error: unknown }>()
);

export const payRatesUpdatedMessageSuccess = createAction('[HUB CONNECTION SERVICE] RATES UPDATED SUCCESSS');
export const payRatesUpdatedMessageFailure = createAction(
    '[HUB CONNECTION SERVICE] RATES UPDATED FAILURE',
    props<{ error: unknown }>()
);

export const payRatesUpdatingMessageSuccess = createAction('[HUB CONNECTION SERVICE] RATES UPDATING SUCCESSS');
export const payRatesUpdatingMessageFailure = createAction(
    '[HUB CONNECTION SERVICE] RATES UPDATING FAILURE',
    props<{ error: unknown }>()
);

export const incentivePayRatesUpdatedMessageSuccess = createAction(
    '[HUB CONNECTION SERVICE] INCENTIVE RATES UPDATED SUCCESSS'
);

export const incentivePayRatesUpdatedMessageFailure = createAction(
    '[HUB CONNECTION SERVICE] INCENTIVE RATES UPDATED FAILURE',
    props<{ error: unknown }>()
);

export const incentivePayRatesUpdatingMessageSuccess = createAction(
    '[HUB CONNECTION SERVICE] INCENTIVE RATES UPDATING SUCCESSS'
);

export const incentivePayRatesUpdatingMessageFailure = createAction(
    '[HUB CONNECTION SERVICE] INCENTIVE RATES UPDATING FAILURE',
    props<{ error: unknown }>()
);

export const loadComponent = createAction(
    '[PAY RATE COMPONENT] Loading component',
    props<{ facilityId: number; facilitySystemId: number }>()
);

export const destroyComponent = createAction('[PAY RATE COMPONENT] Destroying component');

export const setFacilityId = createAction(
    '[PAY RATE COMPONENT] set facility id',
    props<{ facilityId: number; facilitySystemId: number }>()
);

export const setFetchArgs = createAction('[PAY RATE COMPONENT] set fetch args', props<{ args: FetchArgs }>());
